import { QFilterGeneric } from './QFilterGeneric'

export class QFilterPK extends QFilterGeneric {
  name = "pk";
  class_name = "QFilterPK";
  api_name = 'pk';
  
  validate() {
    return this.value != null && this.value.indexOf('QUnit#') == 0 // 'Invalid QUnit PK'
  }
}
